/**
 Input classes for each supported form themes
 */
export const themes = {
  default: {
    default: {
      label: 'text-gray-700 font-semibold',
      input: 'rounded-2xl shadow-sm shadow-moone-light-purple/50 flex-1 appearance-none w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:border-transparent focus:ring-opacity-100',
      help: 'text-gray-400'
    },
    Button: {
      body: 'transition ease-in duration-200 text-center font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-2xl filter hover:brightness-110'
    },
    CodeInput: {
      label: 'text-gray-700 font-semibold',
      input: 'rounded-2xl border border-gray-300 overflow-hidden',
      help: 'text-gray-400'
    },
    RichTextAreaInput: {
      label: 'text-gray-700 font-semibold',
      input: 'rounded-2xl border-gray-300 flex-1 appearance-none border border-gray-300 w-full bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-1 focus:ring-opacity-100 focus:border-transparent focus:ring-2',
      help: 'text-gray-400'
    },
    SelectInput: {
      input: 'relative w-full rounded-2xl shadow-sm shadow-moone-light-purple/50 flex-1 appearance-none w-full px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:border-transparent',
      help: 'text-gray-400'
    },
    ScaleInput: {
      label: 'text-gray-700 font-semibold',
      button: 'cursor-pointer text-gray-700 inline-block rounded-2xl border-gray-300 px-4 py-2 flex-grow text-center',
      unselectedButton: 'bg-white hover:bg-gray-50 border',
      help: 'text-gray-400'
    },
    fileInput: {
      input: 'min-h-16 border border-gray-300 rounded-2xl',
      inputHover: {
        light: 'bg-neutral-50'
      },
      uploadedFile: 'w-full bg-white rounded-2xl shadow-sm'
    }
  },
  simple: {
    default: {
      label: 'text-gray-700 font-semibold',
      input: 'flex-1 appearance-none border border-gray-300 w-full py-2 px-2 bg-white text-gray-700 placeholder-gray-400 text-base focus:outline-none focus:ring-2 focus:border-transparent focus:ring-opacity-100',
      help: 'text-gray-400'
    },
    Button: {
      body: 'transition ease-in duration-200 text-center font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 filter hover:brightness-110'
    },
    SelectInput: {
      input: 'relative w-full flex-1 appearance-none border border-gray-300 w-full px-2 bg-white text-gray-700 placeholder-gray-400 text-base focus:outline-none focus:ring-2 focus:border-transparent',
      help: 'text-gray-400'
    },
    CodeInput: {
      label: 'text-gray-700 font-semibold',
      input: 'border border-gray-300 overflow-hidden',
      help: 'text-gray-400'
    },
    RichTextAreaInput: {
      label: 'text-gray-700 font-semibold',
      input: 'border-transparent flex-1 appearance-none border border-gray-300 w-full bg-white text-gray-700 placeholder-gray-400 text-base focus:outline-none focus:ring-1 focus:ring-opacity-100 focus:border-transparent focus:ring-2',
      help: 'text-gray-400'
    },
    ScaleInput: {
      label: 'text-gray-700 font-semibold',
      button: 'flex-1 appearance-none border-gray-300 w-full py-2 px-2 bg-gray-50 text-gray-700 text-center',
      unselectedButton: 'bg-white hover:bg-gray-50 border -mx-4',
      help: 'text-gray-400'
    },
    fileInput: {
      input: 'min-h-40 border border-dashed border-gray-300 p-4',
      inputHover: {
        light: 'bg-neutral-50'
      },
      uploadedFile: 'border border-gray-300 bg-white shadow-sm max-w-[10rem]'
    }
  },
  notion: {
    default: {
      label: 'text-gray-900 mb-2 block mt-4',
      input: 'rounded border-transparent flex-1 appearance-none shadow-inner-notion w-full py-2 px-2 bg-notion-input-background text-gray-900 placeholder-gray-400 text-base focus:outline-none focus:ring-0 focus:border-transparent focus:shadow-focus-notion',
      help: 'text-notion-input-help'
    },
    Button: {
      body: 'rounded-md transition ease-in duration-200 text-center font-semibold shadow shadow-inner-notion focus:outline-none focus:ring-2 focus:ring-offset-2 filter hover:brightness-110'
    },
    SelectInput: {
      label: 'text-gray-900 mb-2 block mt-4',
      input: 'rounded relative w-full border-transparent flex-1 appearance-none bg-notion-input-background shadow-inner-notion w-full px-2 text-gray-900 placeholder-gray-400 text-base focus:outline-none focus:ring-0 focus:border-transparent focus:shadow-focus-notion',
      help: 'text-notion-input-help'
    },
    CodeInput: {
      label: 'text-gray-900 mb-2 block mt-4',
      input: 'rounded shadow-inner-notion border border-gray-300 overflow-hidden',
      help: 'text-notion-input-help'
    },
    RichTextAreaInput: {
      label: 'text-gray-900 mb-2 block mt-4',
      input: 'rounded border-transparent flex-1 appearance-none shadow-inner-notion border border-gray-300 w-full text-gray-900 bg-notion-input-background shadow-inner placeholder-gray-400 text-base focus:outline-none focus:ring-0 focus:ring-opacity-100 focus:border-transparent focus:ring-0 focus:shadow-focus-notion',
      help: 'text-notion-input-help'
    },
    ScaleInput: {
      label: 'text-gray-900 mb-2 block mt-4',
      button: 'rounded border-transparent flex-1 appearance-none shadow-inner-notion w-full py-2 px-2 bg-notion-input-background text-gray-900 text-center',
      unselectedButton: 'bg-notion-input-background hover:bg-gray-50 border',
      help: 'text-notion-input-help'
    },
    fileInput: {
      input: 'min-h-40 border border-dashed border-gray-300 p-4 rounded bg-notion-input-background',
      inputHover: {
        light: 'bg-neutral-50'
      },
      uploadedFile: 'border border-gray-300 bg-white rounded shadow-sm max-w-[10rem]'
    }
  }

}
